// extracted by mini-css-extract-plugin
export var close = "VacancyModal-module--close--7d98e";
export var title = "VacancyModal-module--title--3038d";
export var content = "VacancyModal-module--content--c97e0";
export var row = "VacancyModal-module--row--7c077";
export var name = "VacancyModal-module--name--92fe0";
export var desc = "VacancyModal-module--desc--dc7cc";
export var footer = "VacancyModal-module--footer--d998a";
export var btn = "VacancyModal-module--btn--3d9c7";